import * as React from "react";
import Svg, { Circle } from "react-native-svg";
const SVGComponent = (props) => (
  <Svg
    width={144}
    height={101}
    viewBox="0 0 144 101"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <Circle
      cx={103.344}
      cy={-2.65556}
      r={103.344}
      fill="white"
      fillOpacity={0.11}
    />
  </Svg>
);
export default SVGComponent;
